import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './Pages/Home';
import Gallery from './Pages/Gallery';
import Error404 from './Pages/Error404';
import Booking from './Pages/Booking';
import Thankyou from './Pages/Thankyou';

const RouteUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Home />}/>
                <Route path='/booking' element={<Booking />}/>
                <Route path='thankyou' element={<Thankyou />}/>
                <Route path='/gallery' element={<Gallery />}/>
                <Route path='*' element={<Error404 />}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RouteUrls;